module.exports = __webpack_public_path__ + "static/media/aravind_pr.74e1b592.png";